// useToasts — единые тосты (успех/ошибка/инфо) вместо локальных div и Pinia-хостов.
// Vanilla reactive: состояние модуля, авто-dismiss по TTL. В App монтируется <ToastsHost />.
//   const toasts = useToasts();
//   toasts.success('Готово'); toasts.error('Не вышло'); toasts.info('...'); toasts.dismiss(id);
import { reactive } from 'vue';

export type ToastKind = 'success' | 'error' | 'info';
export interface Toast { id: number; kind: ToastKind; text: string }

let seq = 1;
const state = reactive<{ items: Toast[] }>({ items: [] });

function push(kind: ToastKind, text: string, ms?: number): number {
  const id = seq++;
  state.items.push({ id, kind, text });
  const ttl = ms ?? (kind === 'error' ? 6000 : 4000);
  if (ttl > 0) setTimeout(() => dismiss(id), ttl);
  return id;
}

function dismiss(id: number): void {
  const i = state.items.findIndex((t) => t.id === id);
  if (i >= 0) state.items.splice(i, 1);
}

export function useToasts() {
  return {
    items: state.items,
    success: (text: string, ms?: number) => push('success', text, ms),
    error: (text: string, ms?: number) => push('error', text, ms),
    info: (text: string, ms?: number) => push('info', text, ms),
    push,
    dismiss,
  };
}
